import {equals, isNil, isNotNil} from 'ramda';
import {isFalse, isNotNilOrEmpty} from 'ramda-adjunct';

import {FiltersRequestBody} from '../../../types/api/api';
import {FilterFormData} from '../../../types/FilterFormData';

const PERCENTAGE_MULTIPLIER = 100;

const mapLocation = (values: FilterFormData) => {
  if (
    isNil(values?.address) ||
    isNil(values.address.lat) ||
    isNil(values.address.lng) ||
    isNil(values?.radius)
  ) {
    return undefined;
  }
  return {lat: values.address.lat, lon: values.address.lng, distance: values.radius};
};

const mapIsVatDeductible = (isVatDeductible: string[]) => {
  if (equals(isVatDeductible, ['YES'])) {
    return true;
  }
  if (equals(isVatDeductible, ['NO'])) {
    return false;
  }
  return undefined;
};

const mapBodyStyle = (bodyStyles?: string[]) => {
  if (isNil(bodyStyles)) {
    return undefined;
  }
  if (bodyStyles.includes('CARSTYLE_VAN')) {
    return [...bodyStyles, 'VANSTYLE_VAN'];
  }
  if (bodyStyles.includes('VANSTYLE_VAN')) {
    return [...bodyStyles, 'CARSTYLE_VAN'];
  }
  return bodyStyles;
};

export const formValuesToRequestValues = (values: FilterFormData): FiltersRequestBody => ({
  location: mapLocation(values),
  bodyStyle: mapBodyStyle(values.bodyStyle),
  title: values.title ?? undefined,
  drive: values.drive ?? undefined,
  fuelType: values.fuelType ?? undefined,
  isVatDeductible: mapIsVatDeductible(values.isVatDeductible),
  hideSoldIn30: isFalse(values.showSoldIn30) ? true : undefined,
  hideSoldIn90: isFalse(values.showSoldIn90) ? true : undefined,
  hideStockCars: isFalse(values.showStockCars) ? true : undefined,
  transmission: values.transmission ?? undefined,
  mileage: {
    gte: values.mileageGte ?? undefined,
    lte: values.mileageLte ?? undefined,
  },
  power: {
    gte: values.powerGte ?? undefined,
    lte: values.powerLte ?? undefined,
  },
  price: {
    gte: values.priceGte ?? undefined,
    lte: values.priceLte ?? undefined,
  },
  firstRegistrationOnYear: {
    gte: values.firstRegistrationOnYearGte ?? undefined,
    lte: values.firstRegistrationOnYearLte ?? undefined,
  },
  featuresLevel: {
    gte: isNotNil(values.featureScoreGte)
      ? values.featureScoreGte / PERCENTAGE_MULTIPLIER
      : undefined,
    lte: isNotNil(values.featureScoreLte)
      ? values.featureScoreLte / PERCENTAGE_MULTIPLIER
      : undefined,
  },
  daysOnStock: {
    gte: values.daysInAdvertisementGte ?? undefined,
    lte: values.daysInAdvertisementLte ?? undefined,
  },
  trimLevel: values.trimLevels ?? undefined,
  features: isNotNilOrEmpty(values.features) ? values.features : undefined,
  sellerType: values.sellerType ?? undefined,
  server: values.server ?? undefined,
});
